import React from 'react'

const JSToDo = () => {
  return (
    <section className="project">
      <p>This is a ToDo App done with Vanilla JavaScript!</p>
      <iframe title="jsToDo" src="https://js-todo-jopemamo.netlify.app/" />
    </section>
  )
}

export default JSToDo;